import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FraudStatmentListComponent } from './fraud-statment-list/fraud-statment-list.component';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { ManageFraudStatmentComponent } from './manage-fraud-statment/manage-fraud-statment.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {  MatFormFieldModule } from '@angular/material/form-field';
const actionRoutes = [
  {
    path: ':id',
    component: FraudStatmentListComponent
  },
  {
    path : ':id/add',
    component : ManageFraudStatmentComponent,
  },
  {
    path : ':id/edit/:statement',
    component : ManageFraudStatmentComponent,

  }
]


@NgModule({
  declarations: [
    FraudStatmentListComponent,
    ManageFraudStatmentComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    RouterModule.forChild(actionRoutes)
  ]
})
export class FraudStatmentModule { }
